// Imports React for UI component construction
import React from 'react';
// Imports logger utility to help track actions and errors
import { logger } from "../../utils/logger";

// Component shows a popup to confirm whether the user wants to delete the app
const DeleteConfirmDialog = ({ app, onConfirm, onCancel }) => {
  // Pull out key information for display
  const { appName, pageCount } = app;

  // Log: Mark that the confirmation dialog has been rendered for a specific app
  logger.log(`📂 [DeleteConfirmDialog] Delete dialog rendered for app: ${appName}`);

  // Handles the cancel action when user decides against deleting
  const handleCancel = () => {
    logger.log(`📂 [DeleteConfirmDialog] Cancel clicked for app: ${appName}`);
    try {
      onCancel();
    } catch (error) {
      logger.error(`📂 [DeleteConfirmDialog] Cancel failed for app: ${appName} - ${error.message}`);
    }
  };

  // Handles delete confirmation when user chooses to proceed
  const handleConfirm = () => {
    logger.warn(`⚠️ [DeleteConfirmDialog] Delete confirmed for app: ${appName}`);
    try {
      onConfirm();
    } catch (error) {
      logger.error(`📂 [DeleteConfirmDialog] Delete failed for app: ${appName} - ${error.message}`);
    }
  };

  // Renders the confirmation dialog with details and actions
  return (
    <div className="delete-dialog-overlay">
      <div className="delete-dialog">
        {/* Shows a warning icon to emphasize caution */}
        <div className="delete-dialog-icon">
          ⚠️
        </div>

        {/* Main title for the confirmation dialog */}
        <h2 className="delete-dialog-title">
          Delete Application?
        </h2>

        {/* Explains what is about to happen, highlighting the app name and its data */}
        <div className="delete-dialog-message">
          <p>
            You are about to delete <strong>"{appName}"</strong>.
          </p>
          <p className="delete-warning">
            This will move the app to deleted status and disable all {pageCount} page{pageCount !== 1 ? 's' : ''}.
          </p>
        </div>

        {/* Shows further app details to help user review before acting */}
        <div className="delete-dialog-app-info">
          <div className="app-info-row">
            <span className="info-label">Application:</span>
            <span className="info-value">{appName}</span>
          </div>
          <div className="app-info-row">
            <span className="info-label">Pages:</span>
            <span className="info-value">{pageCount} page{pageCount !== 1 ? 's' : ''}</span>
          </div>
        </div>

        {/* Note explaining soft delete and restore option */}
        <div className="delete-dialog-note">
          <span className="note-icon">💡</span>
          <span>
            The app will be moved to deleted apps section. You can restore it later by contacting us (charges apply).
          </span>
        </div>

        {/* Action buttons for cancel and confirm, calling handlers above */}
        <div className="delete-dialog-actions">
          <button
            onClick={handleCancel}
            className="btn-dialog-cancel"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            className="btn-dialog-delete"
          >
            Delete Application
          </button>
        </div>
      </div>
    </div>
  );
};

// Exports this dialog so other parts of the app can use it
export default DeleteConfirmDialog;
